import { Actions as COMPANY_ACTIONS } from "@/redux/actions/companyActions";
import { Actions as DEPARTMENT_ACTIONS } from "@/redux/actions/departmentActions";
import { Actions as EMPLOYEE_ACTIONS } from "@/redux/actions/employeeActions";
import { CheckCircleIcon, PlusIcon } from "@heroicons/react/20/solid";
import cleanDeep from "clean-deep";
import { addMonths, format } from "date-fns";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Spinner from "../../common/Spinner";
import DepartmentRow from "./DepartmentRow";

const Departments = ({
	addDepartment,
	departments,
	updateCompanyDetails,
	currentOrg,
	settings,
	saving,
	disabled,
	employeesGetListWithSalary,
}) => {
	const [enableDepartments, setEnableDepartments] = useState(settings?.enableDepartments);

	useEffect(() => {
		employeesGetListWithSalary({});
	}, []);

	useEffect(() => {
		const hasDepartments = departments?.length > 0;
		const disabledSettings = typeof settings?.enableDepartments !== "undefined";
		if (hasDepartments && !disabledSettings) setEnableDepartments(true);
		else setEnableDepartments(settings?.enableDepartments);
	}, [settings?.enableDepartments]);

	const onSubmit = (e) => {
		e.preventDefault();
		e.stopPropagation();
		updateCompanyDetails(
			cleanDeep(
				{
					org: String(currentOrg),
					departments,
					enableDepartments,
				},
				{
					emptyStrings: false,
					emptyArrays: false,
					emptyObjects: false,
				},
			),
		);
	};

	return (
		<>
			<form
				className="form-grid col-3 px-8"
				style={{ paddingBottom: "4rem" }}
				onSubmit={onSubmit}
			>
				<div className="form-section col-span-3 row-span-2">
					<div className="col-xs-6 pull-left form-container">
						<h4>Departments</h4>
					</div>
					{enableDepartments && (
						<div className="col-xs-4 pull-right">
							<button
								className="btn btn-success pull-right"
								type="button"
								disabled={disabled}
								id="add-department-type"
								onClick={() => addDepartment()}
							>
								<PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
								<div style={{ float: "left" }}>Add Department</div>
							</button>
						</div>
					)}

					<div className="col-xs-8 form-container">
						<div className="col-xs-6 pl-0">
							<label className="css-input switch switch-sm switch-success">
								<input
									type="checkbox"
									className="checkbox-toggle"
									disabled={disabled}
									checked={enableDepartments}
									onChange={(e) => setEnableDepartments(e.target.checked)}
								/>
								<span /> Enable Departments
							</label>
						</div>
					</div>

					<div className="col-xs-12">
						{enableDepartments &&
							departments?.map((department) => (
								<DepartmentRow
									key={department.id}
									department={department}
								/>
							))}
					</div>
				</div>

				<div className="col-span-3">
					{!disabled && (
						<div className="text-right">
							<button
								className="btn btn-success"
								type="submit"
							>
								{saving ? (
									<Spinner
										style={{ height: "1.5em", float: "left", marginRight: 5, float: "left" }}
										className="animate-spin -ml-1 mr-3 h-5 w-5"
									/>
								) : (
									<CheckCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
								)}
								<div style={{ float: "left" }}>{saving ? "Saving..." : "Save"}</div>
							</button>
						</div>
					)}
					<div className="clearfix" />
				</div>
				<div className="clearfix" />
			</form>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		isAdmin: state.my?.profile?.isAdmin,
		profile: state?.my?.profile,
		currentOrg: state?.company?.settings?.org,
		settings: state?.company?.settings,
		departments: state.company?.settings?.departments,
		disabled:
			state?.permissions?.my?.permissions?.settings == "Read" || state?.company?.settings?.status == "Archived",
		saving: state.company?.saving,
	};
};

const mapDispatchToProps = (dispatch) => ({
	updateCompanyDetails: (body) => dispatch(COMPANY_ACTIONS.updateCompanyDetails(body)),
	addDepartment: () => dispatch(DEPARTMENT_ACTIONS.addDepartment(null)),
	employeesGetListWithSalary: ({ from, to }) =>
		dispatch(
			EMPLOYEE_ACTIONS.employeesGetListWithSalary(
				{
					from: from ? from : format(addMonths(new Date(), -2), "yyyy-MM-01"), // get list from last 2 months
					to: to ? to : format(new Date(), "yyyy-12-31"),
				},
				{ includeTax: true },
			),
		),
});

export default connect(mapStateToProps, mapDispatchToProps)(Departments);
